import { createConsola } from 'consola/browser'

import { APP_ENV } from 'src/env'

const noop = () => {}

/**
 * @type {import('consola/browser').ConsolaInstance}
 */
const logger =
    APP_ENV.REACT_APP_LOCAL === 'yes'
        ? createConsola({ level: 1000 })
        : { error: noop, info: noop, debug: noop, fatal: noop, warn: noop }

export default logger
